// @flow strict

import * as React from 'react'
import { Link as GatsbyLink } from 'gatsby'

import styles from './PersonDetails.module.scss'

// Child components
const Heading = ({ children }: { children: string | React.Node }) => (
  <h2 className={styles.heading}>{children}</h2>
)

const Text = ({ children }: { children: string | React.Element<'span'> }) => (
  <p className={styles.text}>{children}</p>
)

const Link = ({
  as,
  children,
  href,
}: {
  children: string,
  as?: React.Element<typeof GatsbyLink>,
  href?: string,
}) => {
  if (!as)
    return (
      <a href={href} className={styles.link}>
        {children}
      </a>
    )

  return React.cloneElement(as, { className: styles.link }, children)
}

// Prop types
export type Props = {|
  children: React.ChildrenArray<?React.Element<
    typeof Link | typeof Text | typeof Heading,
  >>,
  image: React.Element<'img'>,
|}

// Component
const PersonDetails = ({ children, image }: Props) => {
  return (
    <div className={styles.container}>
      {image && <figure className={styles.image}>{image}</figure>}
      <div className={styles.content}>{children}</div>
    </div>
  )
}

PersonDetails.Heading = Heading
PersonDetails.Text = Text
PersonDetails.Link = Link

export default PersonDetails
